import { Form } from "react-bootstrap";
import { SortDirection, SortOption, sortOptionValue } from "./sortOptions";

// The "Sort by:" control the leads boards share: the leads inbox, the search
// results list (new and saved), and the saved-searches list. See sortOptions.ts
// for why every option list covers both directions of every sortable column.
//
// Renders as inline children rather than its own bordered row, so each board can
// put it on ONE row to the left of that board's filter chips and the select
// inherits that row's font size - a control sized for the row it sits in rather
// than a second toolbar stacked above the filters.

interface SortBySelectProps<K extends string> {
  options: SortOption<K>[];
  sortKey: K;
  sortDir: SortDirection;
  onChange: (key: K, dir: SortDirection) => void;
  ariaLabel: string;
}

const SortBySelect = <K extends string>({
  options,
  sortKey,
  sortDir,
  onChange,
  ariaLabel,
}: SortBySelectProps<K>) => (
  <>
    <span style={{ color: "#666", marginRight: 4 }}>Sort by:</span>
    <Form.Select
      size="sm"
      value={sortOptionValue(sortKey, sortDir)}
      onChange={(e) => {
        const picked = options.find((o) => o.value === e.target.value);
        if (picked) onChange(picked.key, picked.dir);
      }}
      style={{
        width: "auto",
        // Inherit the row's size so the control matches the filter chips beside
        // it; bootstrap's own sizing would otherwise sit a few px larger.
        fontSize: "inherit",
        padding: "2px 24px 2px 8px",
        height: "auto",
        lineHeight: 1.4,
      }}
      aria-label={ariaLabel}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </Form.Select>
  </>
);

export default SortBySelect;
